import { render, staticRenderFns } from "./ExternalDirectory.vue?vue&type=template&id=c04f1188&"
import script from "./ExternalDirectory.vue?vue&type=script&lang=js&"
export * from "./ExternalDirectory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports